import { toast } from 'react-toastify';

export const handleSuccess = (msg) => {
    toast.success(msg, {
        position: 'top-right',
        autoClose: 5000,
        style: {
            backgroundColor: '#28a745', // Green background for success
            color: '#fff', // White text
            fontWeight: 'bold', // Bold text
            borderRadius: '8px', // Rounded corners
            padding: '10px 20px', // Padding for better readability
            fontSize: '16px', // Larger font size
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)', // Subtle shadow effect
            maxWidth: '300px', // Max width to avoid stretching
            wordWrap: 'break-word', // Break long words if needed
            display: 'flex', // Flexbox for alignment
            justifyContent: 'space-between', // Space between text and close button
            alignItems: 'center', // Align text and close button vertically
        },
        closeButton: true, // Ensures the close button is displayed
    });
}

export const handleError = (msg) => {
    toast.error(msg, {
        position: 'top-right',
        autoClose: 5000,
        style: {
            backgroundColor: '#dc3545', // Red background for errors
            color: '#fff', // White text
            fontWeight: 'bold', // Bold text
            borderRadius: '8px', // Rounded corners
            padding: '10px 20px', // Padding for better readability
            fontSize: '16px', // Larger font size
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)', // Subtle shadow effect
            maxWidth: '300px', // Max width to avoid stretching
            wordWrap: 'break-word', // Break long words if needed
            display: 'flex', // Flexbox for alignment
            justifyContent: 'space-between', // Space between text and close button
            alignItems: 'center', // Align text and close button vertically
        },
        closeButton: true, // Ensures the close button is displayed
    });
}
